import { useId } from 'react';

interface Props {
  className?: string;
}
export function ErrorExplanationMarkCircleIcon({ className }: Props) {
  const titleId = useId();
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-labelledby={titleId}
    >
      <title id={titleId}>Error</title>
      <g clipPath="url(#clip0_9061_296)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.666626 8.00001C0.666626 3.94992 3.94987 0.666672 7.99996 0.666672C12.05 0.666672 15.3333 3.94992 15.3333 8.00001C15.3333 12.0501 12.05 15.3333 7.99996 15.3333C3.94987 15.3333 0.666626 12.0501 0.666626 8.00001ZM7.99996 4.50001C8.36815 4.50001 8.66663 4.79848 8.66663 5.16667V8.50001C8.66663 8.86819 8.36815 9.16667 7.99996 9.16667C7.63177 9.16667 7.33329 8.86819 7.33329 8.50001V5.16667C7.33329 4.79848 7.63177 4.50001 7.99996 4.50001ZM8.83329 10.6667C8.83329 11.1269 8.4602 11.5 7.99996 11.5C7.53972 11.5 7.16663 11.1269 7.16663 10.6667C7.16663 10.2064 7.53972 9.83334 7.99996 9.83334C8.4602 9.83334 8.83329 10.2064 8.83329 10.6667Z"
          fill="#D31400"
        />
      </g>
      <defs>
        <clipPath id="clip0_9061_296">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SuccessCheckCircleIcon({ className }: Props) {
  const titleId = useId();
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-labelledby={titleId}
    >
      <title id={titleId}>Success</title>
      <g clipPath="url(#clip0_9112_265)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99996 0.666672C3.94987 0.666672 0.666626 3.94992 0.666626 8.00001C0.666626 12.0501 3.94987 15.3333 7.99996 15.3333C12.05 15.3333 15.3333 12.0501 15.3333 8.00001C15.3333 3.94992 12.05 0.666672 7.99996 0.666672ZM11.138 5.5286C11.3984 5.78895 11.3984 6.21106 11.138 6.47141L7.47136 10.1381C7.21101 10.3984 6.7889 10.3984 6.52855 10.1381L4.86189 8.47141C4.60154 8.21106 4.60154 7.78895 4.86189 7.5286C5.12224 7.26825 5.54435 7.26825 5.8047 7.5286L6.99996 8.72386L10.1952 5.5286C10.4556 5.26825 10.8777 5.26825 11.138 5.5286Z"
          fill="#2CB87F"
        />
      </g>
      <defs>
        <clipPath id="clip0_9112_265">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ErrorCheckCircleIcon({ className }: Props) {
  const titleId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      role="img"
      aria-labelledby={titleId}
    >
      <title id={titleId}>Error</title>
      <g clipPath="url(#clip0_1593_31451)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.22183 4.21818C-0.0667774 8.50678 -0.0667771 15.4859 4.22183 19.7745C8.51043 24.0631 15.4896 24.0631 19.7782 19.7745C24.0668 15.4859 24.0668 8.50678 19.7782 4.21818C15.4896 -0.0704257 8.51043 -0.0704257 4.22183 4.21818ZM14.3335 11.9964L17.0558 9.27399L14.7224 6.94054L12 9.6629L9.27764 6.94054L6.94419 9.27399L9.66655 11.9964L6.94419 14.7187L9.27764 17.0522L12 14.3298L14.7224 17.0522L17.0558 14.7187L14.3335 11.9964Z"
          fill="#FF867F"
        />
      </g>
      <defs>
        <clipPath id="clip0_1593_31451">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
